import PreparationCoursePage from './PreparationCoursePage';

export default PreparationCoursePage;
